export default __webpack_public_path__ + "media/images/promo-block/rsvp-groups-c6f575b0367dbd52efc0ee49f78ea3eb.gif";